import { Component } from '@angular/core';

import { AuthService } from '@unico-people/shared/dashboard/data-access-auth';

@Component({
  selector: 'unico-people-web-feature-content-layout',
  templateUrl: './feature-content-layout.component.html',
  styleUrls: ['./feature-content-layout.component.scss']
})
export class FeatureContentLayoutComponent {
  isLoggedIn: boolean;
  isOpen = false;

  constructor(
    private authService: AuthService
    )
     {}

  onNotify(notify: boolean): void {
    this.isOpen = notify;
    this.isLoggedIn = true
    this.authService.loggedIn();
  }

  onDeactivate(): void {
    window.scrollTo(0, 0);
  }
}
